import { render } from "./InlineBlock.vue?vue&type=template&id=b8e388c0"
import script from "./InlineBlock.vue?vue&type=script&lang=js"
export * from "./InlineBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__